import { Suspense, useContext } from 'react';
import { Outlet } from 'react-router-dom';

import { styled } from '@mui/material/styles';
import PageImportFallback from '@app/components/PageImportFallback';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Hidden from '@app/components/Hidden';

import { DRAWER_WIDTH } from '@benniehealth/theme';
import Header from '@app/ui/Header';
import { NavigationContext } from '@app/contexts/NavigationContext';

const PREFIX = 'ContentLayout';

const classes = {
  root: `${PREFIX}-root`,
};

const StyledContainer = styled(Container)(({ theme }) => ({
  [`&.${classes.root}`]: {
    position: 'relative',
    display: `flex`,
    flexDirection: `column`,
    alignItems: `center`,
    flexGrow: 1,
    height: '100%',
    padding: '0',
    [theme.breakpoints.up('md')]: {
      marginLeft: DRAWER_WIDTH,
      width: `calc(100% - ${DRAWER_WIDTH}px)`,
      '&.full-width': {
        width: '100%',
        marginLeft: 0,
      },
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
}));

const ContentLayout = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('ContentLayout must be used within NavigationContext.Provider');
  }
  const { onToggleMenu } = context;

  return (
    <>
      <Hidden mdUp>
        <Header onToggleMenu={onToggleMenu} />
      </Hidden>
      <StyledContainer maxWidth={false} className={classes.root}>
        <Box
          position="relative"
          width="100%"
          minHeight="100vh"
          display="flex"
          flexDirection="column"
          flexGrow={1}
        >
          <Suspense fallback={<PageImportFallback />}>
            <Outlet />
          </Suspense>
        </Box>
      </StyledContainer>
    </>
  );
};

export default ContentLayout;
